module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nome),
      expression: "nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nome = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Imagem ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file-input"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "id": "status"
    }
  }, [_vm._v("Please select a file")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h4', [_vm._v("Ativo")]), _c('br'), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.ativo),
      callback: function($$v) {
        _vm.ativo = $$v
      },
      expression: "ativo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('h4', [_vm._v("Habilita multiplo sabor (Pizza)")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.permitemeia),
      callback: function($$v) {
        _vm.permitemeia = $$v
      },
      expression: "permitemeia"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('h4', [_vm._v("Categoria de Produtos Adicionais")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true
    },
    model: {
      value: (_vm.adicionais),
      callback: function($$v) {
        _vm.adicionais = $$v
      },
      expression: "adicionais"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/categorias"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nome != '' && !_vm.gravando),
      expression: "nome!='' && !gravando"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("  Gravar")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a26fd8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/NovaCategoria.vue
// module id = 1273
// module chunks = 1